<template>
  <div class="container">
    <avue-crud
      ref="crud"
      v-model="form"
      :page="page"
      :option="tableOption"
      :data="list"
      @on-load="getList"
      @search-change="handleFilter"
      @refresh-change="handleRefreshChange"
      @row-update="update"
      @row-save="create">

      <template #menu="{row,index,size,type}">
        <el-button
          icon="el-icon-edit"
          :size="size"
          :type="type"
          @click="handleUpdate(row,index)">编辑
        </el-button>
        <el-button
          :size="size"
          :type="type"
         @click="drawerSwitch('permissionSelect', true, row)">授权管理
        </el-button>
      </template>
    </avue-crud>
    <!--授权管理-->
    <PermissionSelectDrawer
      :visible="drawer.permissionSelect.status"
      :data="drawer.permissionSelect.data"
      @close="drawerSwitch('permissionSelect', false)"
    ></PermissionSelectDrawer>
  </div>
</template>

<script>
import {  delObj, rolefetchList,rolesave } from '@/page/system/api/role'
import PermissionSelectDrawer from "./components/PermissionSelectDrawer";

export default {
  name: 'userManage',
  components: {PermissionSelectDrawer },
  data() {
    return {
      drawer: {
        permissionSelect: {
          status: false,
          data: null,
        },
      },

      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },
      form: {},
      list: [],
      tableOption: {
        index: true,
        indexLabel: '序号',
        labelWidth:120,
        indexWidth: 60,
        menuAlign: 'center',
        searchMenuSpan: 6,
        editBtn: false,
        delBtn: false,
        menuWidth: 300,
        dialogWidth: '50%',
        align: 'center',
        viewBtn: false,
        column: [{
          label: '角色名称', prop: 'name', span: 24,
          rules: [{ required: true, message: '角色名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }]
        }, 
        {
          label: '角色标识', prop: 'code', span: 24, editDisabled: true,
          rules: [{ required: true, message: '角色标识不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }]
        },
        {
          label: '排序', prop: 'oindex', span: 24,type:'number',
          rules: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
        },
        {
          label: '角色描述', prop: 'remark', overHidden: true, span: 24,
          rules: [{ required: true, message: '角色描述不能为空', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }]
        }]
      },
      mesh: null
    }
  },
  mounted() {
  },
  methods: {
        // 抽屉切换
    drawerSwitch(drawerName, drawerCase, rowData) {
      this.drawer[drawerName] = {
        status: drawerCase,
        data: rowData || null,
      };
    },
    getList() {
      rolefetchList().then(response => {
        if(response.data.success){
          this.list = response.data.data
        }

      })
    },
    handleRefreshChange() {
      this.getList();
    },
    handleFilter(form,done) {
      if (done) done();
      this.page.currentPage = 1;
      this.getList();
    },
    handleUpdate(row, index) {
      this.$refs.crud.rowEdit(row, index)
    },
    // 编辑新增
    update(row, index, done,loading) {

      rolesave(row).then(res => {
        if (res.data.success) {
            this.$message.success("修改成功");
            this.getList();
          }
          done();
      })
    },

    create(form,done,loading) {
      rolesave(form).then(res => {
        if (res.data.success) {
          this.$message.success("新增成功");
          this.getList();
        }
        done();
      })
    },


    handleDelete(row) {
      this.$confirm('是否要删除用户？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        console.log('row', row)
        delObj(row.id).then((res)=>{
            if(res.code===200){
                this.$message.success('删除成功');
                this.getList();
            }
        })
      }).catch(()=>{});
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
</style>
